/* URL map. Each section component reads the rest of the path itself (see useSubPath), so dotted
   route ids in content ("gitar.egz.1") resolve to "/gitar/egz/1" without a route per level. */
import type { RouteObject } from 'react-router';
import { AkorSection } from '../features/akor/AkorSection';
import { ChangelogPage } from '../features/changelog/ChangelogPage';
import { FactsSection } from '../features/facts/FactsSection';
import { GitarSection } from '../features/gitar/GitarSection';
import { HomePage } from '../features/home/HomePage';
import { JamSection } from '../features/jam/JamSection';
import { NotaSection } from '../features/nota/NotaSection';
import { ProgressPage } from '../features/progress/ProgressPage';
import { SettingsPage } from '../features/settings/SettingsPage';
import { ToolsSection } from '../features/tools/ToolsSection';
import { VokalSection } from '../features/vokal/VokalSection';
import { PageError } from './PageError';
import { Shell } from './Shell';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Shell />,
    errorElement: <PageError />,
    children: [
      {
        // a failing page shows a Turkish error panel inside the shell, like the original app
        errorElement: <PageError />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'gitar/*', element: <GitarSection /> },
          { path: 'nota/*', element: <NotaSection /> },
          { path: 'vokal/*', element: <VokalSection /> },
          { path: 'akor/*', element: <AkorSection /> },
          { path: 'jam/*', element: <JamSection /> },
          { path: 'araclar/*', element: <ToolsSection /> },
          { path: 'az-bilinenler/*', element: <FactsSection /> },
          { path: 'ilerleme', element: <ProgressPage /> },
          { path: 'ayarlar', element: <SettingsPage /> },
          { path: 'yenilikler', element: <ChangelogPage /> },
          { path: '*', element: <HomePage /> },
        ],
      },
    ],
  },
];
